<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (hasNotDisinvestment()) {
      <info [option]="{ icon: 'warning' }">
        Vous devez désinvestir au moins un support pour pouvoir continuer.
      </info>
    }

    <info [option]="{ icon: 'info' }">
      La valorisation en stock du portefeuille est de
      <strong>{{ totalStockValue() | number: '1.2-2' }} €</strong>.
    </info>

    <div class="bloc-btn-duplicate">
      <pr-button
        size="lg"
        type="button"
        display="neutral"
        label="Tout désinvestir"
        rounded
        (onClick)="disinvestAll()"
      ></pr-button>
    </div>

    <supports-table
      [supports]="supportsDivestment"
      [config]="supportsTable"
    ></supports-table>
  </form-wrapper>

  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
    [disabledNext]="disabledNextBtn()"
  ></form-footer>
</form>
